// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface ITripStatusStep {
  /** Статус поездки **/
  tripStatus?: TTripStatusStep_TripStatus;
}

export type TTripStatusStep_TripStatus = null | ETripStatus;

export enum ETripStatus {
  /** Поездка состоялась **/
  'Success' = 'success',
  /** Поездка не состоялась **/
  'Fail' = 'fail',
  /** Условия не подошли **/
  'FailedToAgree' = 'failedToAgree',
  /** Поездка планируется **/
  'Plan' = 'plan',
}
